import type { AuditIndexItem } from "@/types";
import { humanize } from "@/utils/formatters";
import { auditStatusBadgeClasses, auditStatusDotClasses } from "./auditIndexHelpers";

export default function AuditStatusBadge({ audit }: { audit: AuditIndexItem }) {
  return (
    <span
      className={`flex items-center rounded-full px-2.5 py-1 text-xs font-medium ${auditStatusBadgeClasses(audit)}`}
    >
      <span className={`mr-1.5 h-2 w-2 rounded-full ${auditStatusDotClasses(audit)}`} />
      {audit.status === "queued" ? "Pending" : humanize(audit.status)}
    </span>
  );
}
